export default {
  traceability: {
    traceability: "Ufuatiliaji",
    coffeeTraceabilityMngmnt: "Usimamizi wa Ufuatiliaji wa Kahawa",
    traceabilityPage: "Ukurasa wa Ufuatiliaji",
    labelDesigner: "Mubuni wa Lebo",
    additionalInformation: "Taarifa Zaidi",
    info1:
      "Toa taarifa kuhusu nembo za ziada za bidhaa yako. Taarifa hii itapatikana kwa umma kwenye ukurasa wa ufuatiliaji wa kahawa.",
    addSlogan: "Ongeza Kauli Mbiu",
    additionalLogos: "Nembo za Ziada",
    title: "Kichwa",
    description: "Maelezo",
    mapLink: "Kiungo cha Ramani",
    websiteLink: "Kiungo cha Wavuti",
    addMedia: "Ongeza Vyombo vya Habari",
    uploadImageVideo: "Pakia Picha/Video",
    origin: "Asili",
    info2:
      "Toa taarifa kuhusu nchi ya asili ya bidhaa yako. Taarifa hii itapatikana kwa umma kwenye ukurasa wa ufuatiliaji wa kahawa.",
    countryImage: "Picha ya Nchi",
    institutionalInfo: "Taarifa ya Taasisi",
    info3:
      "Toa taarifa kuhusu kampuni/jumuiya yako, waeleze watumiaji juu ya kazi muhimu unazofanya. Taarifa hii itapatikana kwa umma kwenye ukurasa wa ufuatiliaji wa kahawa.",
    cooperativeLogo: "Nembo ya Jumuiya",
    traceabilityIntro: "Utangulizi wa Ufuatiliaji",
    info4:
      "Sehemu hii itawapa watumiaji ufikiaji wa historia nzima ya uzalishaji na usindikaji wa kahawa. Eleze umuhimu wa ufuatiliaji kwa kampuni/jumuiya yako na kwa ulimwengu.",
    addLabel: "Ongeza Lebo",
    chooseTitle: "Chagua Kichwa",
    chooseLabelDesign: "Chagua Kielelezo cha Lebo",
    uploadYourLogo: "Pakia Nembo Yako",
    info5:
      "Maelekezo: Ukubwa wa picha lazima uwe angalau pikseli 1000 x 1000 mraba. Unaweza kuchagua PNG ya Wazi ili itimize rangi za asili.",
    chooseTemplateColors: "Chagua Rangi za Kielelezo",
    backgroundColor: "Rangi ya Msingi",
    foregroundColor: "Rangi ya Mbele",
    labelStatus: "Hali ya Lebo",
    inactive: "Haijafanya Kazi",
    download: "Pakua",
    enterLabelTitle: "Weka Kichwa cha Lebo",
    coffeeInformation: "Taarifa za Kahawa",
    originationCountry: "Nchi ya Asili",
    traceabilityImage: "Picha ya Ufuatiliaji",
    uploadImage: "Pakia Picha",
  },
  cacaoTraceability: {
    traceability: "Ufuatiliaji",
    cacaoTraceabilityMngmnt: "Usimamizi wa Ufuatiliaji wa Kakao",
    traceabilityPage: "Ukurasa wa Ufuatiliaji",
    labelDesigner: "Mubuni wa Lebo",
    additionalInformation: "Taarifa Zaidi",
    info1:
      "Toa taarifa kuhusu nembo za ziada za bidhaa yako. Taarifa hii itapatikana kwa umma kwenye ukurasa wa ufuatiliaji wa kakao.",
    addSlogan: "Ongeza Kauli Mbiu",
    additionalLogos: "Nembo za Ziada",
    title: "Kichwa",
    description: "Maelezo",
    mapLink: "Kiungo cha Ramani",
    websiteLink: "Kiungo cha Wavuti",
    addMedia: "Ongeza Vyombo vya Habari",
    uploadImageVideo: "Pakia Picha/Video",
    origin: "Asili",
    info2:
      "Toa taarifa kuhusu nchi ya asili ya bidhaa yako. Taarifa hii itapatikana kwa umma kwenye ukurasa wa ufuatiliaji wa kakao.",
    countryImage: "Picha ya Nchi",
    institutionalInfo: "Taarifa ya Taasisi",
    info3:
      "Toa taarifa kuhusu kampuni/jumuiya yako, waeleze watumiaji juu ya kazi muhimu unazofanya. Taarifa hii itapatikana kwa umma kwenye ukurasa wa ufuatiliaji wa kakao.",
    cooperativeLogo: "Nembo ya Jumuiya",
    traceabilityIntro: "Utangulizi wa Ufuatiliaji",
    info4:
      "Sehemu hii itawapa watumiaji ufikiaji wa historia nzima ya uzalishaji na usindikaji wa kakao. Eleze umuhimu wa ufuatiliaji kwa kampuni/jumuiya yako na kwa ulimwengu.",
    addLabel: "Ongeza Lebo",
    chooseTitle: "Chagua Kichwa",
    chooseLabelDesign: "Chagua Kielelezo cha Lebo",
    uploadYourLogo: "Pakia Nembo Yako",
    info5:
      "Maelekezo: Ukubwa wa picha lazima uwe angalau pikseli 1000 x 1000 mraba. Unaweza kuchagua PNG ya Wazi ili itimize rangi za asili.",
    chooseTemplateColors: "Chagua Rangi za Kielelezo",
    backgroundColor: "Rangi ya Msingi",
    foregroundColor: "Rangi ya Mbele",
    labelStatus: "Hali ya Lebo",
    inactive: "Haijafanya Kazi",
    download: "Pakua",
    enterLabelTitle: "Weka Kichwa cha Lebo",
  },
};
